import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";

//Functions
import { useMobile } from "../../services/Functions";

//Styles
import "./DrawerMenu.css";

//Icons
import { IoMdClose } from "react-icons/io";
import { TfiMenuAlt } from "react-icons/tfi";
import { FaAngleDoubleLeft } from "react-icons/fa";


export function DrawerMenu({ children }) {
  const isMobile = useMobile()
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() =>{
    if(isMobile == false){
      handleClose()
    }
  },[isMobile])

  return (
    <div className="d-md-none" style={{ position: "absolute", top: "16%", right: '1px', background: '#f5f5f5', zIndex: '4'}}>
      <Button variant="primary" className="button-menu" onClick={handleShow}>
        <FaAngleDoubleLeft size={25} color="#05ca83" />
      </Button>

      <Offcanvas
        show={show}
        onHide={handleClose}
        className="d-md-none drawer-filter"
        placement="end"
      >
        <Offcanvas.Header className="drawer-filter-header">
          <div className="title-filter-header">
            <TfiMenuAlt size={30} color="#05ca83" />
            <h1>Opções</h1>
          </div>
          <button onClick={handleClose} className="button-close">
            <IoMdClose size={25} />
          </button>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div>{React.cloneElement(children, { handleClose })}</div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
